/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmNftActivityRequest = {
    actionType?: EvmNftActivityRequest.actionType;
    page?: number;
    size?: number;
};

export namespace EvmNftActivityRequest {

    export enum actionType {
        MINT = 'MINT',
        SOLD = 'SOLD',
    }


}

